import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const { data } = await api.get("/data/bootstrap");
      setSnapshot(data.snapshot);
    } catch (err) {
      // 401s are handled globally by the api interceptor (redirect to /login).
      // Surface other failures so the shell can show a retry instead of a blank page.
      void err; /* surfaced via error state below */
      if (err?.response?.status !== 401) setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <DataContext.Provider value={{ snapshot, loading, error, reload: load }}>
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
